import { memo, useCallback, useEffect, useState } from "react";

import { modules } from "byzantine";

import Modal from "./components/SurveyModal";

const NpsSurvey = () => {
  const { checkSurveyAvailable, resetFormAndValidationSchema } =
    modules.nps.useCheckSurveyAvailable();

  const [availableSurvey, setAvailableSurvey] = useState<API.NPS.Survey>();

  const close = useCallback(() => {
    setAvailableSurvey(undefined);
    resetFormAndValidationSchema();
  }, [resetFormAndValidationSchema]);

  const tryLaunchSurvey = useCallback(async () => {
    const survey = await checkSurveyAvailable();
    if (!survey) {
      return;
    }
    setAvailableSurvey(survey);
  }, [checkSurveyAvailable]);

  useEffect(() => {
    tryLaunchSurvey();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!availableSurvey) {
    return null;
  }

  return <Modal survey={availableSurvey} close={close} />;
};

export default modules.nps.NpsForm.Wrap(memo(NpsSurvey));
